import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';

export default withStyles(theme => ({
  root: {
    boxShadow: theme.customShadows[1],
  },
}))(Card);
